import { StyleSheet, Dimensions } from 'react-native';

import { Metrics, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

const screenWidth = Dimensions.get('window').width;

export default StyleSheet.create({
  containerStyle: {
    width: screenWidth - Metrics.mainContentPadding * 2,
    marginBottom: 32,
    backgroundColor: '#ffffff',
    borderRadius: 10,
    elevation: 5,
    shadowColor: '#bbbbbb',
    shadowOffset: { width: 1, height: 1 },
    shadowOpacity: 1,
  },
  headerContainerStyle: {
    flex: 1,
    paddingBottom: Metrics.doubleBaseMargin,
    justifyContent: 'center',
  },
  headerStyle: theme => ({
    color: theme.colors.headerTitleColor,
    fontWeight: '500',
    fontSize: 25,
    fontFamily: Fonts.type.bold.fontFamily,
  }),
  itemsContainerStyle: {
    flex: 3,
  },
  showMoreButtonStyle: {
    flex: 0.7,
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: Metrics.doubleBaseMargin,
  },
  showMoreTextStyle: theme => ({
    fontSize: 16.6,
    letterSpacing: 0,
    color: theme.colors.showMoreColor,
    textAlign: 'center',
  }),
});
